import { createContext, useContext } from 'react';
import type { MarketDef } from '@ck/sdk';

/** The market switch in the top bar: every page that lists market data follows it. */
export type MarketFilter = 'all' | string;
export const MarketCtx = createContext<{ market: MarketFilter; setMarket: (m: MarketFilter) => void; markets: MarketDef[] }>({ market: 'all', setMarket: () => undefined, markets: [] });
export const useMarket = () => useContext(MarketCtx);
export const inMarket = (market: MarketFilter, brand: string | null | undefined) => market === 'all' || !brand || brand === market;

/** Download rows as a CSV file. */
let ownerMode = false;
/** Only the owner can take client data out of the CRM. */
export const setOwnerMode = (on: boolean) => { ownerMode = on; };
export const canExport = () => ownerMode;

export function downloadCsv(name: string, rows: Record<string, unknown>[]) {
  if (!ownerMode) return;
  writeCsv(name, rows);
}

/** For a person's own reports, which anyone may download. */
export function writeCsv(name: string, rows: Record<string, unknown>[]) {
  if (!rows.length) return;
  const cols = Object.keys(rows[0]!);
  const esc = (v: unknown) => { const t = v == null ? '' : typeof v === 'object' ? JSON.stringify(v) : String(v); return /[",\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t; };
  const csv = [cols.join(','), ...rows.map((r) => cols.map((c) => esc(r[c])).join(','))].join('\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
  const a = document.createElement('a'); a.href = url; a.download = `${name}-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
